<template>
  <div class="container">
    <div class="row justify-content-center">
      <div class="col">
        
<div class="row mb-3">
          <div class="col"><h5 class="mb-0 align-middle">Affiliate</h5></div>
          <div class="col text-right">
            <a href="/profile/edit-banking" class="btn btn-danger">Edit banking</a>
          </div>
        </div>

        <div class="card">
          <div class="card-body">

    <div class="row d-flex justify-content-center">
        <div class="col-md-6">
            <div class="alert alert-success text-center referral_heading">Here's your referral link<i class="fa-regular fa-clipboard ml-3 clipboard" title="Click to copy" style="color:#fff;" @click="copyTestingCode"></i></div>
            <div class="alert alert-dark text-center link_box" @click="copyTestingCode" title="Click to copy">
                <div>{{displayLink}}</div>
                <input type="hidden" id="testing-code" :value="link">
            </div>
        </div>
    </div>

          </div>
        </div>
           
<b-card no-body class="card mt-3">
      <b-tabs v-model="tabIndex" card align="center">
        <b-tab title="Share" title-link-class="darklink">
          <b-card-text>
            <affiliate-share :url="url"></affiliate-share>
            </b-card-text>
        </b-tab>
        <b-tab title="Banners" title-link-class="darklink">
          <b-card-text>
            <affiliate-banners :url="url"></affiliate-banners>
            </b-card-text>
        </b-tab>
        <b-tab title="Clicks" title-link-class="darklink">
          <b-card-text>
            <affiliate-click-list :user="user"></affiliate-click-list>
          </b-card-text>
        </b-tab>
        <b-tab title="My clients" title-link-class="darklink">
          <b-card-text>
           <affiliate-clients :user="user"></affiliate-clients>
          </b-card-text>
        </b-tab>
        <b-tab title="Transactions" title-link-class="darklink">
          <b-card-text>
            <transactions :user="user" :headless="true"></transactions>
          </b-card-text>
        </b-tab>
        <b-tab title="Banking details" title-link-class="darklink">
          <b-card-text>
            <seller-banking :user="user"></seller-banking>
          </b-card-text>
        </b-tab>
  
      </b-tabs>
    </b-card>
         

        </div>
      </div>
    </div>

</template> 

<script>
export default {
  props: ['user', 'url'],

  data() {
    return {
        link: this.url,
        displayLink: this.url,
        tabIndex: 0,
    };
  },

  created() {
    this.setDisplayLink();
  },

  methods: {
    setDisplayLink() {
      let displayLink = this.link.replace('https://', '');
      displayLink = displayLink.replace('http://', '');
      this.displayLink = displayLink;
    },
    copyTestingCode () {
          let testingCodeToCopy = document.querySelector('#testing-code')
          testingCodeToCopy.setAttribute('type', 'text')
          testingCodeToCopy.select()

          try {
            var successful = document.execCommand('copy');
            this.showToaster('Link has been copied');
          } catch (err) {
            this.showToasterError('Link copy failed');
          }

          /* unselect the range */
          testingCodeToCopy.setAttribute('type', 'hidden')
          window.getSelection().removeAllRanges()
        },
    
    showToaster(text) {
      this.$toaster.success(text, { timeout: 2000 });
    },
    showToasterError(text) {
      this.$toaster.error(text, { timeout: 2000 });
    },
    
  }


}
</script>

<style scoped>
.link_box:hover, .clipboard:hover {
    cursor: pointer;
}
.referral_heading {
  border-top-left-radius: 15px; 
  border-top-right-radius: 15px; 
  border-bottom-left-radius: 0; 
  border-bottom-right-radius: 0;
}

.link_box {
  font-family: "Courier", "Poppins", sans-serif;
  border-bottom-left-radius: 15px; 
  border-bottom-right-radius: 15px;
  border-top-left-radius: 0; 
  border-top-right-radius: 0
}

.alert {
  margin-bottom: 0;
  padding: 0.5rem 1.25rem;
}
.alert-dark {
  color: #1b1e21;
  background-color: #fff;
  border-color: #272c35;
}

.alert-success {
  color: #fff;
  background-color: #272c35;
  border-color: #272c35;
}

</style>